import React from "react";
import "./Menu.css";
import { useNavigate } from "react-router-dom";

export default function Menu() {
  const navigate = useNavigate();

  return (
    <section className="menu-section" id="menu">
      <h2 className="menu-title">OUR OFFERINGS</h2>

      {/* ===== Section 1 ===== */}
      <div className="menu-block">
        <div className="menu-images">
          <img src="/MenuItems/VIPBreakfast.png" alt="Dish 1" />
          <img src="/MenuItems/TurcaBreakfast.png" alt="Dish 2" />
          <img src="/MenuItems/SimitPlatter.jpg" alt="Dish 3" />
          <img src="/MenuItems/PancakeMorningDelight.png" alt="Dish 4" />
        </div>

        <div className="menu-text">
          <h3>Sets</h3>
          <p>
            Experience thoughtfully crafted set meals that bring together our signature dishes in perfect harmony. Whether you’re craving a hearty breakfast, a balanced lunch, or a cozy dinner, each set is designed to showcase the best of our kitchen — fresh, flavorful, and satisfying.
          </p>
          <button className="menu-btn" onClick={() => navigate("/menu/set")}>
            View Full Menu
          </button>
        </div>
      </div>

      {/* ===== Section 2 (reverse layout) ===== */}
      <div className="menu-block reverse">
        <div className="menu-text">
          <h3>Food</h3>
          <p>
            Explore our selection of freshly made dishes, from comforting classics to creative new favorites. Each item is prepared with premium ingredients and attention to detail, ensuring every bite is memorable and delicious.
          </p>
          <button className="menu-btn" onClick={() => navigate("/menu/food")}>
            View Full Menu
          </button>
        </div>

        <div className="menu-images">
          <img src="/food.jpg" alt="Bread 1" />
          <img src="/food.jpg" alt="Bread 2" />
          <img src="/food.jpg" alt="Bread 3" />
          <img src="/food.jpg" alt="Bread 4" />
        </div>
      </div>

      {/* ===== Section 3 ===== */}
      <div className="menu-block">
        <div className="menu-images">
          <img src="/food.jpg" alt="Event 1" />
          <img src="/food.jpg" alt="Event 2" />
          <img src="/food.jpg" alt="Event 3" />
          <img src="/food.jpg" alt="Event 4" />
        </div>

        <div className="menu-text">
          <h3>Deserts</h3>
          <p>
            Indulge your sweet side with our handcrafted desserts. From rich cakes and creamy pastries to light, refreshing treats, every dessert is made in-house with love — the perfect way to end any meal.
          </p>
          <button className="menu-btn" onClick={() => navigate("/menu/dessert")}>
            View Full Menu
          </button>
        </div>
      </div>
    </section>
  );
}
